module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/user/customer/shared/customer-form/customer-form.component.scss
// module id = ./src/app/user/customer/shared/customer-form/customer-form.component.scss
// module chunks = main